import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import reportedIssueService from './ReportedIssueService';
import { Pager } from '../Pager';
import { FormGroup, Form, Input, Button } from 'reactstrap';
import { FaKey,FaSortAlphaDown,FaSortAlphaUp,FaEdit,FaTrash } from 'react-icons/fa';

export class ReportedIssueList extends Component {
	constructor(props) {
		super(props);
		this.state = { entities: [], page: 1, pageSize: 10, maxPages: 5, sortOrder: "Fname", searchString: "", loading: true };
	}

	componentDidMount() {
		this.populateData();
	}

	handlePageChange = (page) => {
		this.setState({ page: page }, () => this.populateData() );
	}

	handleHeaderClick = (event, header) => {
		event.preventDefault();

		let newSortOrder = this.state.sortOrder;

		switch (header) {
			case 'createdon': {
				newSortOrder = this.state.sortOrder === 'createdon' ? 'createdon_desc' : 'createdon';
				break;
			}
			case 'createdon': {
				newSortOrder = this.state.sortOrder === 'path' ? 'path_desc' : 'path';
				break;
			}
		}

		this.setState({ page: 1, sortOrder: newSortOrder }, () => this.populateData());
		return false;
	}

	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({ [name]: value });
	}

	handleSearchFormSubmit = (event) => {
		event.preventDefault();
		this.setState({ page: 1 }, () => this.populateData());
		//this.populateData();
	}

	handleSearchFormReset = (event) => {
		event.preventDefault();
		this.setState({ page:1, searchString: "" }, () => this.populateData());
	}

	renderTable() {
		const { entities, total, sortOrder } = this.state;

		return (
			<div>
				<table className='table table-striped' aria-labelledby="tableLabel">
					<thead>
						<tr>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'createdon')} >
									Date&nbsp;
									{sortOrder == 'createdon' && <FaSortAlphaDown /> }
									{sortOrder == 'createdon_desc' && <FaSortAlphaUp /> }
								</a>
							</th>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'path')} >
									Path&nbsp;
									{sortOrder == 'path' && <FaSortAlphaDown />}
									{sortOrder == 'path_desc' && <FaSortAlphaUp />}
								</a>
							</th>
							<th />
							<th />
						</tr>
					</thead>
					<tbody>
						{entities.map(entity =>
							<tr key={entity.id}>
								<td>{new Date(entity.createdOn.replace("T", " ")).toLocaleString()}</td>
								<td>{entity.path ? entity.path.name : ''}</td>
								<td><Link to={'/reportedissues/delete/' + entity.id}><FaTrash /></Link></td>
								<td><Link to={'/reportedissues/edit/' + entity.id}><FaEdit /></Link></td>
							</tr>
						)}
					</tbody>
				</table>
				<Pager totalItems={total} page={this.state.page} pageSize={this.state.pageSize} maxPages={this.state.maxPages} handlePageChange={this.handlePageChange} />
			</div>
		);
	}

	render() {
		let contents = this.state.loading
			? <p><em>Loading...</em></p>
			: this.renderTable();

		return (
			<div>
				<h1 id="tableLabel">Reported Issues</h1>
				<Form inline onSubmit={this.handleSearchFormSubmit}>
					<FormGroup>
						<Input type="text" name="searchString" value={this.state.searchString} onChange={this.handleInputChange} placeholder="Search text" />
					</FormGroup>&nbsp;
					<Button>Search</Button>&nbsp;
					<Button onClick={this.handleSearchFormReset}>Reset</Button>
				</Form><br/>
				{contents}
			</div>
		);
	}

	async populateData() {
		try {

			const data = await reportedIssueService.getData(this.state.page, this.state.pageSize, this.state.sortOrder, this.state.searchString);
			this.setState({ total: data.total, entities: data.entities, loading: false });
		}
		catch (error) {
			// Handle error
		}
	}
}